<div class="h1">h1</div>
<div class="h2">h2</div>
<div class="h3">h3</div>
<div class="h4">h4</div>
<div class="strong">strong</div>
<p>paragraph</p>
<div class="content">content</div>
<div class="caption">caption</div>
<div class="label">label</div>

buttons
<button class="btn btn--primary">btn btn-primary</button>
<button class="btn btn--secondary">btn btn-secondary</button>
<input class="input" type="text" placeholder="placeholder" value="value">

link <a href="" class="link--primary">Aktywuj swoje konto</a>


separators
<div class="separator"></div>
<div class="separator--double"></div>
<div class="separator--quad"></div>
<div class="separator--hexa"></div>
<div class="separator--deca"></div>

margins
<div class="mr-2"></div>

gui blocker

<button class="btn btn--primary" (click)="showBlockUi()">Show blockUi</button>

<app-logo></app-logo>
<app-logo-project [size]="'10rem'"></app-logo-project>
